import { IAppState } from '../../common/state';
import { selectIsAgent } from '../user';
import { selectIsSpecialProjectFeaturesAvailable } from './selectIsSpecialProjectFeaturesAvailable';

export const selectIsSpecialProjectAdfoxBannerVisible = (state: IAppState) => {
  const isSpecialProjectFeatureAvailable = selectIsSpecialProjectFeaturesAvailable(state);
  const isAgent = selectIsAgent(state);

  if (isAgent) {
    return false;
  }

  if (!isSpecialProjectFeatureAvailable || state.newbuildingPromoBuilderOffers === null) {
    return false;
  }

  return state.newbuildingPromoBuilderOffers.needShowAdfoxBlock;
};
